import { render } from "./WordCard.vue?vue&type=template&id=26298aa1&scoped=true"
import script from "./WordCard.vue?vue&type=script&lang=js"
export * from "./WordCard.vue?vue&type=script&lang=js"

import "./WordCard.vue?vue&type=style&index=0&id=26298aa1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26298aa1"]])

export default __exports__